<fut-base-dialog-icon [dialogTitle]="'Aggiornamento in corso...'" [enableAutoClose]="false" [showSpinner]="true">
  <div class="w-100 text-center">
    <span>{{ message }}</span>
  </div>
</fut-base-dialog-icon>
